<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-7">
				<sf-card class="p-0 h-100 card_bg">
					<mk-obj-search ref="mkObjectSearch" :scrId="scrId" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 시작-->
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<mk-obj-table
						ref="table"
						@PopupMkObjectMstNewOpen="PopupMkObjectMstNewOpen"
						@PopupRoOpen="PopupRoOpen"
						@Refresh="Refresh"
						:scrId="scrId"
					/>
					<mk-obj-popup ref="mkObjectPopup" @Refresh="Refresh" :scrId="scrId" />
					<ro-apcn-popup ref="roApcnPopup" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 끝-->
		</div>
	</div>
</template>

<script>
import MkObjSearch from './Search/MkObjSearch.vue'; //클레임현황
import MkObjTable from './Table/MkObjTable.vue'; //클레임현황
import MkObjPopup from './MkObjPopup/MkObjPopup.vue'; //협력사 이의제기
import RoApcnPopup from '@mqy/ceqi/RoApcn/Content/RoApcnPopup/RoApcnPopup.vue'; //RO 신청 현황 팝업부분

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { MkObjSearch, MkObjTable, MkObjPopup, RoApcnPopup },
	methods: {
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.mkObjectSearch.searchList();
		},
		PopupMkObjectMstNewOpen(param) {
			//this.userName = param.userName;

			//console.log('ContentView 에서의 param값 ::::: ', param);

			this.$refs.mkObjectPopup.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		},
		PopupRoOpen(param) {
			//alert('여기호출');

			this.$refs.roApcnPopup.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		}
	}
};
</script>

<style></style>
